(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const initialize = () => {
    document.querySelectorAll('header-menu:has(.custom-mega-menu)').forEach((menu) => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      const details = menu.querySelector('.custom-mega-menu');
      const summary = details.querySelector('summary');
      let closeTimer;
      menu.addEventListener('pointerenter', () => {
        if (!desktopHover.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.custom-mega-menu[open]').forEach((other) => {
          if (other === details) return;
          other.open = false;
          other.querySelector('summary').setAttribute('aria-expanded', 'false');
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('pointerleave', () => {
        if (!desktopHover.matches) return;
        closeTimer = setTimeout(() => {
          if (menu.contains(document.activeElement)) return;
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 250);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
